import { Alert, Box, Checkbox, CircularProgress, FormControlLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { IdentityRole } from '@/types/identity/Identity';

interface RoleCheckboxListProps {
  /** The roles the caller may assign; undefined while they load. */
  roles: IdentityRole[] | undefined;
  /** Names of the checked roles. */
  selected: ReadonlySet<string>;
  onToggle: (roleName: string) => void;
}

/**
 * The assignable roles as checkboxes — the user-edit page's role picker and the Users grid's
 * "Assign roles" dialog.
 */
export function RoleCheckboxList({ roles, selected, onToggle }: RoleCheckboxListProps) {
  const { t } = useTranslation();

  if (!roles) {
    return <CircularProgress size={20} />;
  }

  if (roles.length === 0) {
    return <Alert severity="info">{t('identity.noRoles')}</Alert>;
  }

  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 0.5 }}>
      {roles.map((role) => (
        <FormControlLabel
          key={role.id}
          control={
            <Checkbox
              checked={selected.has(role.name)}
              onChange={() => onToggle(role.name)}
              size="small"
            />
          }
          label={role.name}
        />
      ))}
    </Box>
  );
}
